
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 0C4.469 0 0 4.483 0 10.031c0 5.548 4.469 10.031 10.125 9.968C15.687 19.968 20.03 15.36 20 9.906 19.969 4.45 15.469 0 10 0zm-.938 3.668c0-.44.375-.721.875-.721s.875.282.875.69c.032 1.253.032 2.507.032 3.76 0 .408-.375.69-.907.69h-.062c-.469-.03-.813-.282-.813-.69V5.549v-1.88zm1.782 12.476c-.313.062-.625.062-.844.062-3.656-.094-6.313-2.883-6.219-6.426.031-1.348.531-2.539 1.375-3.605.063-.062.094-.125.156-.156a.898.898 0 01.625-.283c.47 0 .875.408.875.878a.721.721 0 01-.125.44c-.03.062-.062.156-.125.218-1 1.286-1.25 2.696-.75 4.232.625 1.85 2.5 3.104 4.407 2.947 2.093-.157 3.75-1.63 4.093-3.636.22-1.317-.093-2.477-.906-3.543-.094-.125-.219-.25-.25-.407a.768.768 0 010-.376c.063-.439.406-.784.844-.784.219 0 .437.063.594.282a5.82 5.82 0 011.468 3.166c.47 3.48-1.78 6.426-5.218 6.99z"}})])
          )
        }
      }
    